import { BaseModel } from '../../shared/entities/base.model';
import {AnswerModel, AnswersTypeModel} from './answer.model';
import {QuestionModel} from './question.model';

export class QuestionnaireModel extends BaseModel {
    id: string;
    uid: string;
    name: string;
    forUser: string;
    questions: Array<QuestionModel> = [];
    implicit: boolean = false;
    isDoneByMe: string;
    created_at: Date;
    updated_at: Date;
}
